/**
 * @generated SignedSource<<faaa3e61a5376fb0c0659aee3d606757>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesEditorSettingsMenuRooms_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorRoomSettings_package">;
  readonly " $fragmentType": "RoomRatesEditorSettingsMenuRooms_package";
};
export type RoomRatesEditorSettingsMenuRooms_package$key = {
  readonly " $data"?: RoomRatesEditorSettingsMenuRooms_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorSettingsMenuRooms_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesEditorSettingsMenuRooms_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorRoomSettings_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "6c33ea1d54f68338df9b01c4e0281a53";

export default node;
